import "./eagerStyles";
import React from "react";
import ReactDOM from "react-dom";
import "./pages/index/Index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration.js";
import { installSupportGrantInterceptor } from "./utils/supportGrant";
import { validateEnv } from "./utils/validateEnv";

validateEnv();
installSupportGrantInterceptor();

// Disable console log for production
if (process.env.REACT_APP_STAGE === "PROD") {
  console.log = () => {};
}
ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById("root"),
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

// Register service worker for PWA
serviceWorkerRegistration.register();
